import Swiper from 'swiper';
import 'swiper/css';

export default class WebStoriesList {
    /* ——— Loader YouTube API ——— */
    static ytAPILoader = null;

    static loadYouTubeAPI() {
        if (WebStoriesList.ytAPILoader) return WebStoriesList.ytAPILoader;

        WebStoriesList.ytAPILoader = new Promise(resolve => {
            if (window.YT && window.YT.Player) {
                resolve(window.YT);
                return;
            }
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(tag);
            window.onYouTubeIframeAPIReady = () => resolve(window.YT);
        });

        return WebStoriesList.ytAPILoader;
    }

    constructor() {
        this.sections = document.querySelectorAll('.block-latest-webstories');
        this.init();
    }

    async init() {
        if (this.sections.length === 0) return;

        const YT = await WebStoriesList.loadYouTubeAPI();

        this.sections.forEach(section => {
            /* Swiper */
            const slider = section.querySelector('.swiper');
            new Swiper(slider, {
                grabCursor: true,
                allowTouchMove: true,
                spaceBetween: 28,
                breakpoints: {
                    0: { slidesPerView: 1.2, slidesOffsetAfter: 28, slidesOffsetBefore: 28 },
                    1200: { slidesPerView: 4, slidesOffsetAfter: 0, slidesOffsetBefore: 0 }
                }
            });

            /* Stories */
            const allStories = section.querySelectorAll('.block-webstories-item');
            let currentStory = null;

            allStories.forEach(story => {
                story.addEventListener('click', () => {
                    const id = story.dataset.id;
                    if (!id) return;

                    const contentEl = story.querySelector('.content');
                    const isPlaying = story.classList.contains('playing');

                    /* Toggle no mesmo card */
                    if (isPlaying) {
                        story.querySelector('iframe')?.remove();
                        contentEl?.classList.remove('opacity-0', 'invisible');
                        story.classList.remove('playing');
                        currentStory = null;
                        return;
                    }

                    /* Remove player anterior */
                    if (currentStory && currentStory !== story) {
                        const prevContent = currentStory.querySelector('.content');
                        currentStory.querySelector('iframe')?.remove();
                        prevContent?.classList.remove('opacity-0', 'invisible');
                        currentStory.classList.remove('playing');
                    }

                    /* Oculta thumbnail */
                    contentEl?.classList.add('opacity-0', 'invisible');

                    /* Wrapper para player */
                    const wrapper = document.createElement('div');
                    const iframeId = `yt-${crypto.randomUUID()}`;
                    wrapper.id = iframeId;
                    wrapper.className = 'w-full h-full absolute inset-0 rounded-xl';
                    story.appendChild(wrapper);

                    story.classList.add('playing');
                    currentStory = story;

                    /* Instancia player */
                    new YT.Player(iframeId, {
                        videoId: id,
                        playerVars: {
                            autoplay: 1,
                            mute: 1,              // obrigatório p/ autoplay
                            playsinline: 1,
                            rel: 0,
                            enablejsapi: 1
                        },
                        // events: {
                        //     onReady: e => e.target.playVideo(),
                        //     // onStateChange: e => {
                        //     //     if (e.data === YT.PlayerState.PLAYING) {
                        //     //         /* desmute após breve delay */
                        //     //         setTimeout(() => {
                        //     //             if (e.target.getPlayerState() === YT.PlayerState.PLAYING) {
                        //     //                 e.target.unMute();
                        //     //             }
                        //     //         }, 500);
                        //     //     }
                        //     // }
                        // }
                    });

                    /* Ajusta permissões explicitamente */
                    const iframe = wrapper.querySelector('iframe');
                    if (iframe) {
                        iframe.allow =
                            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
                        iframe.allowFullscreen = true;
                    }
                });
            });
        });
    }
}

/* Instanciar automaticamente */
if (document.querySelector('.block-latest-webstories')) {
    new WebStoriesList();
}
